export default {
  DOCUMENT: {
    mask: ['999.999.999-99', '99.999.999/9999-99'],
    autoUnmask: true
  },
  DOCUMENT_OR_TEXT: {
    mask: ['999.999.999-99', '99.999.999/9999-99', '[F]{1,255}'],
    showMaskOnHover: false,
    showMaskOnFocus: false,
    autoUnmask: true
  },
  PHONE: {
    mask: ['(99) 9999-9999', '(99) 99999-9999'],
    autoUnmask: true
  },
  BILLET_LINE_CODE: {
    regex: '([8]{1}[0-9]{11} [0-9]{12} [0-9]{12} [0-9]{12})|([0-9]{5}\\.[0-9]{5} [0-9]{5}\\.[0-9]{6} [0-9]{5}\\.[0-9]{6} [0-9]{1} [0-9]{14})',
    autoUnmask: true
  },
  DATE: {
    mask: '99/99/9999',
    placeholder: 'dd/mm/aaaa',
    clearMaskOnLostFocus: false
  },
  CURRENCY: {
    alias: 'currency',
    radixPoint:',',
    groupSeparator: '.',
    numericInput: true,
    allowMinus: false,
    prefix: 'R$ ',
    digits: 2,
    digitsOptional: false,
    rightAlign: false,
    unmaskAsNumber: false,
    autoUnmask: true
  }
};